module.exports = __webpack_public_path__ + "fc97d6487b0df1ec9e7b5ab027029e56.jpg";